module.exports = __webpack_public_path__ + "static/media/muravidekre_logo.3a4b4590.jpg";